module.exports = __webpack_public_path__ + "static/media/hollow_bar_M3_tall.f88f1ce6.svg";